import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  customerList?: any
  customerOptionList?: any
  customerDetail?: any
  reloadCustomerList?: string | null
  modalCustomer?: IModalBase
}

const initialState: IState = {
  customerList: [],
  customerOptionList: [],
  customerDetail: {},
  reloadCustomerList: null,
  modalCustomer: {
    visible: false,
    record: {}
  }
}

export const customerDucks = createSlice({
  name: 'customer',
  initialState,
  reducers: {

    getListCustomer: (state: RootState, action: PayloadAction<any>) => {
      state.customerList = { loading: true, queryStr: action.payload }
    },
    getListCustomerSuccess: (state, action: PayloadAction<any>) => {
      state.customerList = { loading: false, ...action.payload }
    },
    getListCustomerFail: (state, action: PayloadAction<any>) => {
      state.customerList = { loading: false, ...action.payload }
    },

    getListOptionCustomer: (state: RootState, action: PayloadAction<any>) => {
      state.customerOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionCustomerSuccess: (state, action: PayloadAction<any>) => {
      state.customerOptionList = { loading: false, ...action.payload }
    },
    getListOptionCustomerFail: (state, action: PayloadAction<any>) => {
      state.customerOptionList = { loading: false, ...action.payload }
    },

    getDetailCustomer: (state: RootState, action: PayloadAction<any>) => {
      state.customerDetail = { loading: true, id: action.payload }
    },
    getDetailCustomerSuccess: (state, action: PayloadAction<any>) => {
      state.customerDetail = { loading: false, ...action.payload }
    },
    getDetailCustomerFail: (state, action: PayloadAction<any>) => {
      state.customerDetail = { loading: false, ...action.payload }
    },

    setReloadCustomerList: (state: RootState) => {
      state.reloadCustomerList = String(moment())
    },
    setModalCustomer: (state, action: PayloadAction<IModalBase>) => {
      state.modalCustomer = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListCustomer,
  getListCustomerSuccess,
  getListCustomerFail,

  getListOptionCustomer,
  getListOptionCustomerSuccess,
  getListOptionCustomerFail,

  getDetailCustomer,
  getDetailCustomerSuccess,
  getDetailCustomerFail,

  setReloadCustomerList,
  setModalCustomer
} = customerDucks.actions

export default customerDucks.reducer
